import { useStaticQuery, graphql } from 'gatsby';

const useTaxonomyQuery = () => {
  const query = useStaticQuery(graphql`
  query MyTaxonomyQuery {
    allWpTermNode {
      nodes {
        name
        nodeType
        slug
      }
    }
  }`);

  return query.allWpTermNode.nodes;
};

export default useTaxonomyQuery;
